import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";
import EMPDataCard from "../../shared/components/EMPDataCard/EMPDataCard";
import { formatPriceValue } from "../../utils/FormatPrice";
import { useTranslation } from "react-i18next";
import { LincolnDetailsCard } from "./PurchaseRequestDetails";

const ProtectionPlan = ({ protectionPlansData, isLincolnBrand = false }) => {
  const { t } = useTranslation();

  const formatDeductibleString = (deductibleStr) => {
    if (deductibleStr) {
      const cleanedStr = deductibleStr.replaceAll("$", "").replaceAll(",", "");
      const number = Number.parseFloat(cleanedStr);
      return `$${number}`;
    }
    return "--";
  };

  const getDeductibleDisplay = (item) => {
    if (item.deductible !== null && item.deductible !== undefined) {
      return formatPriceValue(item.deductible, "--");
    }
    if (item.deductibleStr !== null && item.deductibleStr !== undefined) {
      return formatDeductibleString(item.deductibleStr);
    }
    return "--";
  };

  const includedPlan = [
    {
      heading: t("vehicle.protectionPlans.fields.0.fields.0"),
      content: "New Vehicle Limited Warranty",
    },
  ];
  const selectedPlans = protectionPlansData?.protectionPlans || [];
  const PlanCard = isLincolnBrand ? LincolnDetailsCard : EMPDataCard;

  return (
    <>
      {!isLincolnBrand && (
        <Typography variant="caption" component="p" sx={{ mb: 2 }}>
          {t("vehicle.protectionPlans.fields.0.heading")}
        </Typography>
      )}
      <PlanCard data={includedPlan} />
      {selectedPlans.length > 0 && (
        <>
          <Typography
            variant={isLincolnBrand ? "h5" : "caption"}
            component={isLincolnBrand ? "h3" : "p"}
            sx={{ mt: 6, mb: 2 }}
          >
            {t("vehicle.protectionPlans.fields.1.heading")}
          </Typography>
          {selectedPlans.map((item) => (
            <Box sx={{ mb: 4 }} key={item.planName}>
              <PlanCard
                data={[
                  {
                    heading: t("vehicle.protectionPlans.fields.1.fields.0"),
                    content: item.planName,
                  },
                  {
                    heading: t("vehicle.protectionPlans.fields.1.fields.1"),
                    content: formatPriceValue(item.dealerSellingPrice, "--"),
                  },
                  {
                    heading: t("vehicle.protectionPlans.fields.1.fields.2"),
                    content: item.term ? `${item.term} MO` : "--",
                  },
                  {
                    heading: t("vehicle.protectionPlans.fields.1.fields.3"),
                    content: item.annualMileage
                      ? `${Number.parseFloat(item.annualMileage).toLocaleString()} Miles`
                      : "--",
                  },
                  {
                    heading: t("vehicle.protectionPlans.fields.1.fields.4"),
                    content: getDeductibleDisplay(item),
                  },
                ]}
              />
            </Box>
          ))}
        </>
      )}
    </>
  );
};

ProtectionPlan.propTypes = {
  protectionPlansData: PropTypes.shape({
    protectionPlans: PropTypes.arrayOf(
      PropTypes.shape({
        planName: PropTypes.string,
        dealerSellingPrice: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
        term: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        annualMileage: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
        deductible: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        deductibleStr: PropTypes.string,
      })
    ),
  }),
  isLincolnBrand: PropTypes.bool,
};

ProtectionPlan.defaultProps = {
  protectionPlansData: null,
};

export default ProtectionPlan;
